import { IAIChatItem, streamToAnswerItemWithMarkdown } from '@dauyan/ai-chat';
import { logError } from '@/utils/logger/arms-config';
import i18n from '@/locales/init'; 

export interface IListeningAIRemoteItem {
  ai_content: string;
  content: string;
  id: number;
  paper_id: string;
  type: string;
  analyze: string;
}

// 题目解析数据
const getAnalyzeLocalData = (ele: IListeningAIRemoteItem & { type: 'Analysis'; }): IAIChatItem => {
  const reference: any = {};
  if ((ele as any).reference) {
    reference.content = (ele as any).reference.content;
    reference.payload = (ele as any).reference.payload ? JSON.parse((ele as any).reference.payload) : '';
  }

  
  const contentData = typeof (ele as any).analyze === 'string' ? JSON.parse(ele.analyze) : null;

  return {
    id: `${ele.id}`,
    type: ele.type,
    question: contentData.question,
    reference,
    answer: contentData.answer,
  };
};


const normalGetLocalData = (ele: IListeningAIRemoteItem): IAIChatItem => {
  
  const reference: any = {};
  if ((ele as any).reference) {
    reference.content = (ele as any).reference.content;
    reference.payload = (ele as any).reference.payload ? JSON.parse((ele as any).reference.payload): '';
  }

  if (ele.content && ele.ai_content) {
    return {
      id: `${ele.id}`,
      type: ele.type || 'Asking',
      question: ele.content,
      reference,
      answer: streamToAnswerItemWithMarkdown(ele.ai_content),
    };
  }



  const contentData = typeof (ele as any).analyze === 'string' ? JSON.parse(ele.analyze) : null;
  if (!contentData) {
    throw ele;
  }

  const question = ele.content || contentData.question || '';
  const answer = [];

  if (contentData.answer && contentData.answer.length > 0) {
    answer.push(...contentData.answer);
  }

  return {
    id: `${ele.id}`,
    type: ele.type,
    question,
    reference,
    answer: answer,
  };
};

export const remoteToLocal = (remote: IListeningAIRemoteItem): IAIChatItem => {
  try {
    switch (remote.type) {
      case 'Analysis': {
        return getAnalyzeLocalData({ ...remote, type: 'Analysis' });
      } // case 'Asking': {
      //   return getAskingLocalData({ ...remote, type: 'Asking' });
      // }
      default: {
        return normalGetLocalData(remote);
      }
    }
  } catch (e) {
    logError(new Error(`AI会话记录解析错误：remoteId=${remote.id}`));
    return {
      id: `${remote.id}`,
      type: remote.type,
      question: i18n.t('common.dauyan_no_data_found'),
      answer: [{
        key: Date.now().toString(),
        content: i18n.t('common.dauyan_no_data_found'),
        type: 'stream-text',
      }],
    };
  }

};
